import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const Grid = ({ list, Wrapper, ItemWrapper, Item, children, width, columns, gridIdentifier }) => {
  return (
    <Wrapper className="Grid" style={{ '--columns': columns, '--content-width': width }}>
      {list ? (
        list.map(props => {
          const { id } = props;
          return (
            <ItemWrapper {...props} key={`${gridIdentifier}-${id}`}>
              <Item {...props} />
            </ItemWrapper>
          );
        })
      ) : (
        <div>
          <strong>No data available</strong>
        </div>
      )}
      {children}
    </Wrapper>
  );
};

Grid.propTypes = {
  children: PropTypes.element,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  ),
  Wrapper: PropTypes.func.isRequired,
  ItemWrapper: PropTypes.func,
  Item: PropTypes.func,
  gridIdentifier: PropTypes.string.isRequired,
  columns: PropTypes.number,
  width: PropTypes.string,
};

Grid.defaultProps = {
  // eslint-disable-next-line react/prop-types
  ItemWrapper: ({ children }) => <>{children}</>,
  children: null,
  Item: () => <div />,
  columns: 4,
  width: '100vw',
  list: [],
};

export default Grid;
